import React, { useState } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { MESSAGES } from "../utils/const";
import { ME } from "../graphql/query";
import { useQuery } from "@apollo/client/react";
import AdminOnboardModel from "../components/AdminOnboardModel";
import { MeQueryResponse } from "../interfaces/auth.interface";
import CustomSnackbar from "../components/Snackbar";
import AdminDrawer from "../components/AdminDrawer";
import ViewAdminDrawer from "../components/ViewAdminDrawer";
import AdminDashboard from "../components/AdminDashboard";
import SuperAdminDashboard from "../components/SuperAdminDashboard";
import InstructorDashboard from "../components/InstructorDashboard";
import StudentDashboard from "../components/StudentDashboard";
const Home:React.FC = () => {
  const { data, loading } = useQuery<MeQueryResponse>(ME);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isViewDrawerOpen, setIsViewDrawerOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState<"success" | "error" | "info">("success");
  const location = useLocation();
  if (loading) return null; 
  const showOnboard = data?.me?.isFirstLoggedIn === true;
  const isSuperAdmin = data?.me?.role === "SUPER_ADMIN";
  const isAdmin = data?.me?.role === "ADMIN";
  const isInstructor = data?.me?.role === "INSTRUCTOR";
  const isUser = data?.me?.role === "USER";
  const isDashboardRoute = ["/dashboard", "/home", "/DashboardLayout"].includes(location.pathname);
   const handleSubmitSuccess = () => {
    setSnackbarMessage(MESSAGES.ONBOARD_SUCCESS);
    setSnackbarType("success");
    setSnackbarOpen(true);
  };
  return (
    <>
      {isDashboardRoute && (isSuperAdmin || isAdmin) ? (
        <SuperAdminDashboard />
      ) : isDashboardRoute && isInstructor ? (
        <InstructorDashboard />
      ) : isDashboardRoute && isUser ? (
        <StudentDashboard />
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "24px",
            fontWeight: "bold",
            minHeight: "calc(100vh - 160px)",
          }}
        >
          {MESSAGES.WORK_IN_PROGRESS}
        </Box>
      )}

      <AdminDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      <ViewAdminDrawer open={isViewDrawerOpen} onClose={() => setIsViewDrawerOpen(false)} />

      {showOnboard && !isSuperAdmin && <AdminOnboardModel onSubmit={handleSubmitSuccess} />}

      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        type={snackbarType}
        onClose={() => setSnackbarOpen(false)}
      />
    </>
);
};
export default Home;
